'use client';

import { useQuery, useSuspenseQuery } from '@tanstack/react-query';
import { SITECONFIG_QUERIES } from '../../infrastructure/siteconfig/utils/queries';
import type { GetShippingPolicyRequest } from '../../infrastructure/siteconfig/utils/types';

export const useSiteconfigService = () => {
  const useGetShippingPolicies = () => {
    return useQuery(SITECONFIG_QUERIES.getShippingPolicies());
  };

  const useGetShippingPoliciesSuspenseQuery = () => {
    return useSuspenseQuery(SITECONFIG_QUERIES.getShippingPolicies());
  };

  const useGetShippingPolicyByCurrency = (params: GetShippingPolicyRequest) => {
    return useQuery(SITECONFIG_QUERIES.getShippingPolicy(params));
  };

  return {
    useGetShippingPolicies,
    useGetShippingPoliciesSuspenseQuery,
    useGetShippingPolicyByCurrency,
  };
};
